import MyAccountComponent from "../components/MyAccount.component";
import QrCodeComponent from "../components/QrCode.component";

const accountRoutes = [
  {
    paths: [
      '/my-account',
    ],
    exact: true,
    component: MyAccountComponent
  },
  {
    paths: [
      '/qrcode',
    ],
    exact: true,
    component: QrCodeComponent
  },
]

const routes = accountRoutes
  .map(({ paths, ...rest }) => paths.map((path) => ({ path, ...rest })))
  .flat();

export default routes;